var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":_vm.link}},[_c('span',{staticClass:"nav-item"},[_c('i',{class:_vm.fullIconName})]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.header)}}),(_vm.label)?_c('sup',{staticClass:"headerLabel"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }